export default "__VITE_ASSET__BhvZHCuP__"